import type { PayloadFormatter } from '../shared/types';

export const formatTerminalPayload: PayloadFormatter = () => null;
